export default __webpack_public_path__ + "static/media/forms-modal.d3162079.svg";